import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useApiAuth } from "../hooks/useApiAuth";

export const SessionExpiredModal: React.FC = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const {
    isApiReady,
    isLoading,
    hasAttemptedAuth,
    beginInteractiveLogin,
    isStartingInteraction,
  } = useApiAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show modal if user is authenticated with MSAL but API token is invalid/expired
    // and we're not currently trying to acquire a token
    // AND we have actually attempted to authenticate at least once (to avoid showing on initial load)
    if (isAuthenticated && !isApiReady && !isLoading && hasAttemptedAuth) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [isAuthenticated, isApiReady, isLoading, hasAttemptedAuth]);

  const loginDisabled =
    inProgress !== "none" || isLoading || isStartingInteraction;

  const handleLogin = async () => {
    if (loginDisabled) return;
    await beginInteractiveLogin();
  };

  return (
    <Dialog
      header="Session Expired"
      visible={visible}
      style={{ width: "450px" }}
      modal
      closable={false}
      onHide={() => {}} // Prevent closing by clicking outside or escape
      footer={
        <div>
          <Button
            label="Log In"
            icon="pi pi-sign-in"
            onClick={handleLogin}
            disabled={loginDisabled}
            autoFocus
          />
        </div>
      }
    >
      <div className="flex align-items-center gap-3 mb-3">
        <i className="pi pi-exclamation-triangle text-yellow-500 text-4xl" />
        <span>
          Your session has expired or the authentication token could not be
          refreshed. Please log in again to continue working.
        </span>
      </div>
    </Dialog>
  );
};
